import { Flex, IconWithTooltip } from '@solinkcorp/solink-components';
import { type SvgIconComponent } from 'utils/types';

function ActivityTitle({
  title,
  icon,
  tooltipText,
}: {
  title: string;
  icon?: SvgIconComponent;
  tooltipText?: string;
}) {
  return (
    <Flex alignItems="center" className="event-detail event-detail-title-wrapper">
      <p className="event-detail-title">{title}</p>
      {icon && (
        <IconWithTooltip
          className="event-detail-title-tooltip"
          tooltipContainerClassName="scheduled-activity-title-tooltip-container"
          icon={icon}
          iconSize={16}
          title={tooltipText ?? ''}
        />
      )}
    </Flex>
  );
}

export default ActivityTitle;
